import { ContentType } from '@/constants/content.constants';
import { ApiResponse, PaginatedResponse } from '@/types/Common';
import { AppContent } from '@/types/content.types';
import {
  AddUserPayload,
  GetUsersArgs,
  UpdateUserPayload,
  User,
} from '@/types/User';
import api from '@/utils/axios/api';

export const getUsers = async (args?: GetUsersArgs) => {
  const response = await api.get<ApiResponse<PaginatedResponse<User>>>(
    '/users',
    { params: args },
  );
  return response.data.data;
};

export const createUser = async (data: AddUserPayload) => {
  const response = await api.post<ApiResponse<User>>('/users', data);
  return response.data.data;
};

export const updateUser = async (data: UpdateUserPayload) => {
  const { id, ...rest } = data;
  const response = await api.put<ApiResponse<User>>(`/users/${id}`, rest);
  return response.data.data;
};

export const getAppContent = async (type: ContentType) => {
  const response = await api.get<ApiResponse<AppContent>>(
    `/app-contents/${type}`,
  );
  return response.data.data;
};

export const acceptTermsAndPrivacyPolicy = async () => {
  const response = await api.put<ApiResponse<AppContent>>(
    `/users/accept-terms-and-privacy`,
  );
  return response.data.data;
};
